<!--
<div class="dropdown-container" style="margin-bottom: 20px;">
  <select [(ngModel)]="selectedOption" (change)="onOptionChange($event)">
    <option value="" disabled selected>Select Filter Type</option>
    <option *ngFor="let option of options" [value]="option.value">{{ option.name }}</option>
  </select>
  <input *ngIf="showInput" type="text" [(ngModel)]="inputValue" placeholder="Type a value" />
  <button *ngIf="showButton" (click)="filter()">Filter</button>
  <button *ngIf="showButton" (click)="clearFilter()">Clear Filter</button>
</div> -->


<div class="container-fluid pagecard list-page-main" id="addons-list-page">

  <div class="gross-tabs-sec border-bottom position-relative" style="z-index: 900">
    <nav ngbNav #nav="ngbNav" class="nav-tabs gross_tabs" [(activeId)]="active">

      <ng-container [ngbNavItem]="1">
        <a ngbNavLink routerLink="/merchants">{{'Active' | translate | async }}</a>
      </ng-container>

      <ng-container [ngbNavItem]="2">
        <a ngbNavLink routerLink="/merchants/merchant-archived">{{'Archived' | translate | async }}</a>
      </ng-container>

      <ng-container [ngbNavItem]="3">
        <a ngbNavLink routerLink="/merchants/merchant-onboard">{{'New Onboard' | translate | async }}</a>
      </ng-container>

      <ng-container [ngbNavItem]="4">
        <a ngbNavLink> {{ 'Internal' | translate | async }}</a>
        <ng-template ngbNavContent>
          <div *ngIf="isEmpty" class="empty-courses d-none">
            <div class="text-center">
              <img src="../../../../assets/images/empty-add-on-groups.svg" class="mb-3">
              <h2 class="fw-600 mb-3">{{ "Merchant" }}</h2>
              <p class="f-16 mb-3">{{ "No Merchants Available" }}</p>
              <!-- <button class="create-btn" (click)="goToAddPage()">
                {{ "New Merchant" }}
              </button> -->
            </div>
        </div>

        <div *ngIf="!isEmpty" class="position-relative" style="margin-top: -56.5px">
          <div class="table-responsive d-grid">
              <table id="addons-table" datatable class="display" cellspacing="0" width="100%" [dtOptions]="dtOptions">
                <thead>
                    <tr>
                      <!-- <th class="text-left">
                        <input type="checkbox"  style="width: 20px;" [checked]="allMerchantsSelected" (change)="toggleSelectAll($event)">
                      </th> -->
                        <th class="text-left">Merchant Name</th>
                        <th class="text-center">Email</th>
                        <th class="text-center">Contact No</th>
                        <th class="text-center">Store</th>
                        <th class="text-center">License Expiry</th>
                    </tr>
                </thead>
                <tbody class="fw-500">
                    <tr *ngFor="let merchant of merchants"  style="cursor: pointer;" class="table-row">
                      <!-- <td style="width: 20px;">
                        <input
                          type="checkbox"
                          [(ngModel)]="merchant.selected"
                          (change)="selectMerchant($event, merchant)"
                        >
                      </td> -->
                      <td  (click)="goToMerchantDetailsPage(merchant)"  class="text-left">{{merchant.merchantName}}</td>
                        <!-- <td class="text-center">{{merchant.merchantEmail}}</td> -->
                        <td class="text-center">
                          <ng-container *ngIf="merchant.merchantEmail; else noEmailTemplate">
                            {{ merchant.merchantEmail }}
                          </ng-container>
                          <ng-template #noEmailTemplate>
                            <span>No Email Available</span>
                          </ng-template>
                        </td>
                        <!-- <td class="text-center">{{merchant.merchantMobile}}</td> -->
                        <td class="text-center">
                          <ng-container *ngIf="merchant.merchantMobile; else noMobileTemplate">
                            {{ merchant.merchantMobile }}
                          </ng-container>
                          <ng-template #noMobileTemplate>
                            <span>No Mobile Available</span>
                          </ng-template>
                        </td>
                        <td class="text-center">
                          {{merchant?.stores[0]?.storeName}}
                          <span *ngIf="merchant.stores.length > 1">+ {{merchant.stores.length - 1}} </span>
                        </td>
                        <!-- <td class="text-center">{{ merchant.licenseExpiration * 1000 | date:'MMM d, y, h:mm a' }}</td> -->
                        <td class="text-center">
                          <div class="hidden-menu">
                            <ng-container *ngIf="merchant.licenseExpiration; else errorTemplate">
                              {{ _convertDate(merchant.licenseExpiration) }}
                            </ng-container>
                            <ng-template #errorTemplate>
                              <span>No Expiry Date available.</span>
                            </ng-template>
                          </div>

                          <div class="hover-menu">
                            <button class="tooltip-custom"
                            (click)="goToMerchantDetailsPage(merchant)"
                            accessControl module="Merchants" access="3"
                            >
                              <img
                                src="/assets/images/Edit.svg"
                                alt="edit"
                              />
                              <div class="cust-tool">Edit</div>
                            </button>
                            <button class="tooltip-custom"
                            accessControl module="Merchants" access="3"
                            (click)="deleteMerchant(merchant.merchantId, contentArchive)"
                            >
                              <img
                                src="/assets/images/archive.svg"
                                alt="archive"
                              />
                              <div class="cust-tool">Archive</div>
                            </button>
                          </div>
                        </td>
                        <td>
                          <div ngbDropdown container="body">
                              <div class="cursor-pointer" ngbDropdownToggle>
                                <!-- <i class="fas fa-ellipsis-v"></i> -->
                              </div>
                              <div ngbDropdownMenu>
                                <button ngbDropdownItem  (click)="OpenThirdPartyModel(merchant)">
                                  Onbord though third party
                                </button>
                              </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
              </table>
          </div>
          <div class="position-absolute signupbtn">
            <!-- <button class="new-btn" (click)="deleteMerchantsmodel()" style="margin-right: 10px;">
              Delete Selected
            </button> -->
            <!-- <button class="new-btn" (click)="goToMerchantSignupPage()">
              + Sign Up
            </button> -->
          </div>
        </div>
        </ng-template>
      </ng-container>

      <ng-container [ngbNavItem]="5">
        <a ngbNavLink routerLink="/merchants/quick-actions">{{'Quick Actions' | translate | async }}</a>
      </ng-container>

    </nav>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

  <!-- Open third party model  -->
  <ng-template #ThirdPartyModel let-c="close" let-d="dismiss" class="">
    <div class="model_verify">
      <div class="modal-body p-0">
        <div class="d-flex modal_heading justify-content-between">
          <div class="f-20 fw-600" style="width: 100%; margin-right: 10px;">
            Import Third Party Menu
          </div>
          <div>
            <img src="assets\images\closeIcon.svg" class="" (click)="d('Cross click');" />
          </div>
        </div>
        <div class="modal_content">
          <p class="m-0 fs-14 fw-400 import_txt">Select the third party that you’d like to import from now, you can use
            one option at one time.</p>
          <div class="import_boxs">
            <div class="box_theme w-100 d-flex align-items-center" [ngClass]="TpartyGrubButtonActive ? 'activeBox':''"
              (click)="TpartycardActive()">
              <div><img src="assets\images\GrubHub.png" alt=""></div>
              <div>
                <p class="fs-16 fw-500 m-0">GrubHub</p>
              </div>
            </div>
            <div class="box_theme w-100 d-flex align-items-center"  [ngClass]="TpartyUberButtonActive ? 'activeBox':''" (click)="TpartycardActive()">
              <div><img src="assets\images\uber.png" alt=""></div>
              <div>
                <p class="fs-16 fw-500 m-0">Uber Eats</p>
              </div>
            </div>
            <div class="box_theme w-100 d-flex align-items-center">
              <div><img src="assets\images\doordash.png" alt=""></div>
              <div>
                <p class="fs-16 fw-500 m-0">DoorDash</p>
              </div>
            </div>
            <div class="box_theme w-100 d-flex align-items-center">
              <div><img src="assets\images\other.png" alt=""></div>
              <div>
                <p class="fs-16 fw-500 m-0">Others</p>
              </div>
            </div>
            <div class="next_button">
              <button [ngClass]="TpartyButtonActive ? 'activeButton':''"
                class="next_theme text-white fs-18 fw-700 border-0 w-100" [disabled]="!TpartyButtonActive"
                (click)="OpenGuruHubModel()">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- GruHub Model -->

<ng-template #GuruHubModel let-c="close" let-d="dismiss" class="">
    <div class="guruhub">
      <div class="modal-body p-0">
        <div class="d-flex modal_heading justify-content-between">
          <div class="f-20 fw-600" style="width: 100%; margin-right: 10px;">
            Import Third Party Menu
          </div>
          <div>
            <img src="assets\images\closeIcon.svg" class="" (click)="d('Cross click');" />
          </div>
        </div>
        <div class="modal_content_two">
          <p class="m-0 fs-16 fw-600 guruhu_txt">Find your GrubHub menu</p>
          <p class="para_text fs-14 fw-400">Find and paste the public URL of your restaurant’s GrubHub page below.</p>
          <div class="input_box">
            <div class="w-100 input_theme d-flex align-items-center relative">
              <img src="assets\images\GrubHub.png" alt="">
              <textarea placeholder="paste your link or url" class="border-0 text_fuild w-100" name="" id="" cols="30"
                rows="10" [(ngModel)]="MenuUrl"></textarea>
              <img *ngIf="tpartymenuSetup" src="assets\images\verifiytrue.png" class="true_icon" alt="">
            </div>
          </div>
          <div *ngIf="!tpartymenuSetup">
            <div class="url_content">
              <h5 class="fs-14 fw-500 text_black">How to get URL:</h5>
              <ul class="list">
                <li class="fs-12 fw-500">Search for your restaurant on GrubHub website</li>
                <li class="fs-12 fw-500">Select your restaurant from the search results to view the public page</li>
                <li class="fs-12 fw-500">Copy the URL of your restaurant’s page </li>
              </ul>
            </div>
            <div class="d-grid url_image">
              <img src="assets\images\urlarrow.png" class="mx-auto" alt="">
              <img src="assets\images\urlimage.png" alt="" class="mx-auto url_theme">
            </div>
          </div>
          <div class="" *ngIf="tpartymenuSetup">
            <div class="input_part">
              <label for="" class="fs-14 fw-500">Menu Name</label>
              <input type="text" class="input_theme_two p-0 w-100" [(ngModel)]="MenuName" (keyup)="activebtn($event)"
                placeholder="Enter menu name">
            </div>
            <div class="select">
              <select class="input_theme_two w-100 fs-13 fw-500 text-black" [(ngModel)]="murchandlocation" [ngModelOptions]="{standalone: true}" name="language" >
                <option value="" selected disabled>Select Location</option>
                <option *ngFor="let location of locations" [value]="location.id">
                    {{ location.name }}
                </option>
            </select>
            </div>
            <!-- <div class="select m-0 pt-5  w-100 fs-13 fw-500 text-black">
                <ng-multiselect-dropdown [placeholder]="'Choose Location(s) ...'" [settings]="dropdownSettings2"
                  [data]="locations" [(ngModel)]="selectedItems2" (onSelect)="onItemSelect($event)"
                  (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown>
            </div> -->

          </div>
          <div class="end_button d-flex align-items-center">
            <button class="w-100 mt-4 fs-18 fw-700 text-white back_theme border-0"
              (click)="OpenThirdPartyModel('')">Back</button>
            <button *ngIf="!tpartymenuSetup" class="w-100 mt-4 fs-18 fw-700 text-white Continue_theme border-0"
              (click)="OpenGuruHubModel2('url')">Continue</button>
            <button *ngIf="tpartymenuSetup" class="w-100 mt-4 fs-18 fw-700 text-white Continue_theme border-0"
              (click)="saveUberHurts()" [ngClass]="continuetrue ? 'activeButtontwo':''">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #Delete role="document" let-modal>
    <div class="modal-body border-0">
        <div class="delete-icon-info text-center">
            <div class="swal2-icon swal2-warning swal2-icon-show" style="border: 0.25em solid; border-color: #facea8; color: #f8bb86; position: relative; box-sizing: content-box; justify-content: center; width: 5em; height: 5em; margin: 2.5em auto 0.6em; border-radius: 50%;">
                <div class="swal2-icon-content" style="align-items: center; font-size: 3.75em;">
                    !
                  </div>
              </div>
            <h2 class="swal2-title" id="swal2-title">
                {{ "Are you sure?" | translate | async }}
            </h2>
        </div>
    </div>
    <div class="modal-footer border-0">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 text-center">
                    <button class="btn add-btn-one fw-bold mb-2 mt-2 mr-2" style="margin-right: 10px;" (click)="deleteSelectedMerchants()">
                        {{ "Yes, delete it!" | translate | async }}
                      </button>

                      <button class="btn btn-dark fw-bold add-btn-two mb-2 mt-2" (click)="cancelDeleteAll(content)">
                        {{ "Cancel" | translate | async }}
                      </button>
                </div>
            </div>
        </div>
    </div>
  </ng-template>
  <ng-template #content role="document" let-modal>
    <div class="modal-body border-0">
      <div class="menu_text">
        <h3 class="f-16 fw-500 text-center px-5">Your menu is being retrieved from UberEats. We will send you an email once done.</h3>
        <!-- <h5 class="f-16 fw-500 text-center">We’re already working on building your uploaded menu. You can create another menu, but note that your requested menu will appear as a separate menu.</h5> -->
      </div>
    </div>
    <div class="modal-footer border-0">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 text-center">
            <button class="btn btn-success  fw-bold"  (click)="cancelDeleteAll(content)">
             OK!
            </button>
            <!-- <button class="btn btn-dark add-btn-two fw-bold" style="margin-left: 15px" (click)="cancelDeleteAll(content)">
              Cancel
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #contentArchive role="document" let-modal>
    <div class="modal-body border-0">
      <div class="delete-icon-info">
        <div class="delete-icon-info-img">
          <div
            class="swal2-icon swal2-warning swal2-icon-show"
            style="display: flex; animation: none !important"
          >
            <div class="swal2-icon-content">!</div>
          </div>
          <h2 class="swal2-title" id="swal2-title" style="display: flex">
            Are you sure?
          </h2>
        </div>
      </div>
    </div>
    <div class="modal-footer border-0">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 text-center">
            <button
              class="btn btn-success add-btn-one fw-bold"
              (click)="deleteMerchantFunction(contentArchive)"
            >
              Yes, archive it!
            </button>
            <button
              class="btn btn-dark add-btn-two fw-bold"
              style="margin-left: 15px"
              (click)="cancelDeleteAll2(contentArchive)"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- <ng-template #GuruHubModel2 let-c="close" let-d="dismiss" class="">
    <div class="guruhub">
      <div class="modal-body p-0">
        <div class="d-flex modal_heading justify-content-between">
          <div class="f-20 fw-600" style="width: 100%; margin-right: 10px;">
            Import Third Party Menu
          </div>
          <div>
            <img src="assets\images\closeIcon.svg" class="" (click)="d('Cross click');" />
          </div>
        </div>
        <div *ngIf="!progreessbar">
          <div class="modal_content_three">
            <div>
              <div class="justify-content-between prosess_text d-flex align-items-center">
                <p class="fs-14 fw-700 m-0">0%</p>
                <p class="fs-14 fw-700 m-0">98%</p>
              </div>
              <div class="progress">
                <div class="progress-bar bg-black w-75" role="progressbar" style="width: 100%" aria-valuenow="98"
                  aria-valuemin="0" aria-valuemax="98" (click)="progressbar()"></div>
              </div>
            </div>
            <div class="progress_text text-center">
              <h5 class="fs-16 fw-500">Pulling information from GrubHub</h5>
              <p class="fs-12 fw-500">This can take up to one minute, do not close or refresh the webpage</p>
            </div>
          </div>
          <div class="done_button">
            <button class="Done_theme text-white fs-18 fw-700" [ngClass]="progreessbar ? 'activeButton':''">Done</button>
          </div>
        </div>
        <div class="" *ngIf="progreessbar">
          <div class="modal_content_three">
            <div>
              <div class="justify-content-between prosess_text d-flex align-items-center">
                <p class="fs-14 fw-700 m-0">0%</p>
                <p class="fs-14 fw-700 m-0">100%</p>
              </div>
              <div class="progress">
                <div class="progress-bar bg-black w-100" role="progressbar" style="width: 100%" aria-valuenow="98"
                  aria-valuemin="0" aria-valuemax="98" (click)="progressbar()"></div>
              </div>
            </div>
            <div class="progress_text text-center">
              <h5 class="fs-21 fw-600">Congratulations! Your Menu imported successfully</h5>
            </div>
            <div class="select pt-5">
              <select class="input_theme_two w-100 fs-13 fw-500 text-black" name="" id="">
                <option value="1">Location #1, Location #3, Location #7</option>
                <option value="1">Location #1, Location #3, Location #7</option>
                <option value="1">Location #1, Location #3, Location #7</option>
                <option value="1">Location #1, Location #3, Location #7</option>
              </select>
            </div>
          </div>
          <div class="done_button">
            <button class="Done_theme_two text-white fs-18 fw-700" style="background-color: #212121;"
              [ngClass]="progreessbar ? 'activeButton':''" (click)="d('Cross click');">Done</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template> -->



